import styled from "styled-components";
import { Button } from "../../../../Components/Button";

export const SignUpFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: auto;
  min-height: auto;
  max-height: none;
  overflow: visible;
  width: 100%;
  gap: ${(props) => props.theme.spacing.medium};
  padding: ${(props) => props.theme.spacing.medium};

  h1 {
    text-align: center;
    margin-bottom: 0.5rem;
    margin-top: 0;
  }

  p.subtitle {
    text-align: center;
    color: #565869;
    margin-bottom: ${(props) => props.theme.spacing.medium};
    font-size: ${(props) => props.theme.fontSizes.small};
    margin-top: 0;
  }

  button {
    width: 100%;
  }

  button:not(.nextstep) {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.font.primary};
    border: 1px solid ${(props) => props.theme.colors.border};
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding: ${(props) => props.theme.spacing.small};
    gap: ${(props) => props.theme.spacing.small};
    padding-bottom: ${(props) => props.theme.spacing.large};
  }
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${(props) => props.theme.spacing.medium};

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    gap: ${(props) => props.theme.spacing.small};
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${(props) => props.theme.spacing.medium};

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: ${(props) => props.theme.spacing.small};
  }
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  p {
    font-size: ${(props) => props.theme.fontSizes.small};
  }
`;

export const SeparatorWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: ${(props) => props.theme.spacing.medium} 0;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background-color: #ECECEC;
  }

  span {
    padding: 0 ${(props) => props.theme.spacing.medium};
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #989898;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    margin: ${(props) => props.theme.spacing.small} 0;
  }
`;

export const PasswordWrapper = styled.div`
  position: relative;
  width: 100%;

  .password-hint {
    font-size: 0.75rem;
    color: #565869;
    margin-top: 0.25rem;
    text-align: left;
  }
`;

export const LoginLink = styled.b`
  color: #34d399;
  cursor: pointer;
  font-weight: 600;

  &:hover {
    color: #10b981;
    text-decoration: underline;
  }
`;

export const FooterLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-size: 0.75rem;
  color: #9ca3af;

  a {
    color: #9ca3af;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: #e5e7eb;
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
    gap: 1rem;
    font-size: 0.7rem;
  }
`;

export const RegisterButton = styled(Button)`
  background-color: #021526 !important;
  color: white !important;
  font-weight: 600;
  padding: 0.875rem 1rem !important;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover:not(:disabled) {
    background-color: #032940 !important;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  svg {
    width: 1.25rem;
    height: 1.25rem;
    transition: transform 0.2s;
  }

  &:hover:not(:disabled) svg {
    transform: translateX(2px);
  }
`;

export const NavigateParagraph = styled.span`
  font-size: ${(p) => p.theme.fontSizes.small};
  font-weight: 300;
  text-align: center;
  > b {
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

